import { Button } from '@heroui/react';
import { LucideInfo, RefreshCcwIcon } from 'lucide-react';
import { type ComponentProps, Fragment } from 'react';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';
import { cn } from '@/lib/utils';

interface InfiniteListDefaultEmptyListProps extends ComponentProps<'div'> {
	retry?: () => void;
}
export function InfiniteListDefaultEmptyList({ children, className, retry }: InfiniteListDefaultEmptyListProps) {
	return (
		<Empty className={cn('size-full', className)}>
			{children ?? (
				<Fragment>
					<EmptyHeader>
						<EmptyMedia variant="icon">
							<LucideInfo />
						</EmptyMedia>
						<EmptyTitle>Nada por aqui ainda</EmptyTitle>
						<EmptyDescription className="max-w-xs text-pretty">Você está a par de tudo. Novos recursos aparecerão aqui.</EmptyDescription>
					</EmptyHeader>
					{!!retry && (
						<EmptyContent>
							<Button variant="bordered" onPress={retry} startContent={<RefreshCcwIcon className="size-4" />}>
								Recarregar
							</Button>
						</EmptyContent>
					)}
				</Fragment>
			)}
		</Empty>
	);
}
